import React, {useEffect, useRef} from 'react';
import {Sphere} from '@react-three/drei';
import {BackSide} from 'three';
import {useThree} from '@react-three/fiber';
import './SphericalGradientBackground';

const BackgroundSphere = () => {
  const mesh = useRef();

  const sphereMaterial = useRef();
  const viewport = useThree(state => state.viewport);
  useEffect(() => {
    const width = viewport.width * viewport.factor;
    const height = viewport.height * viewport.factor;
    const s = 1; // 2 if antialiasing
    sphereMaterial.current?.uniforms.resolution.value.set(s * width, s * height);
  }, [viewport.factor, viewport.height, viewport.width]);

  return (
    <Sphere ref={mesh} args={[100]}>
      <sphericalGradientMaterial ref={sphereMaterial} attach="material" side={BackSide}/>
    </Sphere>
  );
};

export default BackgroundSphere;